import React, { useEffect } from 'react';
import { ajaxURL , state, view} from '../variables';
import { usePFDataContext } from '../context/PfContext';
import cloneDeep from 'lodash/cloneDeep';


import ProductList from '../components/ProductList';
import ScrollToTopButton from '../components/ScrollToTopButton';
import Cart from '../components/Cart';


// StateDropdown
import StateDropdown from '../components/StateDropdown';
import Spinner from '../components/Spinner';


const Store = () => {
    const { pfData, updatePfData, showAlert } = usePFDataContext();

    useEffect(() => {
       

        function LoadPFProducts() {
            const form = new FormData();
            form.append('action', 'pf_load_products');
            form.append('state',pfData.pfState);

            fetch(ajaxURL, {
                method: 'POST',
                body: form
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    console.log('Data:', data);
                    if (data.success) {
                        // let { data: pfdata } = data;
                        const { grouped_results: pfProducts } = data.data;
                        const { button_1_text, button_2_text, button_3_text, button_1_url, button_2_url, button_3_url,  store_emails } = data.data;
                        // Extract unique categories and strains
                        const categories = new Set();
                        const strains = new Set();

                        Object.values(pfProducts).forEach((brand) => {
                            Object.keys(brand.categories || {}).forEach((categoryName) => {
                                categories.add(categoryName);

                                // Extract unique strains
                                (brand.categories[categoryName] || []).forEach((product) => {
                                    if (product.strain) strains.add(product.strain.toLowerCase());
                                });
                            });
                        });



                        updatePfData({
                            pfProducts,
                            pfProductBrands: Object.keys(pfProducts).sort((a, b) => {
                                if (pfProducts[a].order === pfProducts[b].order) {
                                    return a.localeCompare(b);
                                }
                                return pfProducts[a].order - pfProducts[b].order;
                            }),
                            filteredpfProducts: cloneDeep(pfProducts),  // Clone filtered products
                            pfProductCategories: Array.from(categories).sort(),
                            pfProductStrains: Array.from(strains).sort(),
                            storeEmails: store_emails || {}, 
                            pfButton1: { text: button_1_text, url: button_1_url },
                            pfButton2: { text: button_2_text, url: button_2_url },
                            pfButton3: { text: button_3_text, url: button_3_url },
                            isLoading: false // Set isLoading to false after successful fetch

                        });
                    } else {
                        showAlert(data.message || 'No products found.');
                        updatePfData({ isLoading: false }); // Set isLoading to false on failure

                    }

                    
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                    showAlert('Error fetching products. Please try again.');
                    updatePfData({ isLoading: false }); // Set isLoading to false on failure

                })
                
        }

        LoadPFProducts();
    }, [pfData.pfState]); // Dependencies to trigger effect

    // pfData.pfState

    return (
        <div>


            {pfData.isLoading  ? (
                <Spinner />
            ) : (
                <>
                { pfData.pfView === 'private' && 
                    <StateDropdown />
                }
                {pfData.pfProductBrands.length > 0 ? (
                    <>
                            <ProductList />
                            <ScrollToTopButton />
                            <Cart />
                    </>
                    
                ) : (
                    null
                )}
                </>
            )}


        </div>
    );
};

export default Store;
